class NSSIngredientCard extends HTMLElement {
    connectedCallback() {
        this._btn = this.querySelector('.nss-ingredient-card__btn-open');
        this._btn?.addEventListener('click', () => this.toggle());
    }

    toggle() {
        this.classList.contains('is-open') ? this.close() : this.open();
    }

    open() {
        this.classList.add('is-open');
        this._btn?.setAttribute('aria-expanded', 'true');
        this._btn?.setAttribute('aria-label', 'Close');
    }

    close() {
        this.classList.remove('is-open');
        this._btn?.setAttribute('aria-expanded', 'false');
        this._btn?.setAttribute('aria-label', 'Learn more');
    }
}

const elementName = 'nss-ingredient-card';
if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, NSSIngredientCard);
} else {
    console.warn(`[NSS] Element '${elementName}' already defined.`);
}
